export const TERMS_AND_CONDITIONS_TYPE_ID = 10;

export interface IMandatoryNotification {
	Notification_ID: number;
	Message: string;
	Subject: string;
	Created_Date: Date;
	Expiration_Date: Date;
	Must_Accept: boolean;
	Type: string;
	Read_Date?: Date | null;
	Status: string;
	Type_ID: number;
	NotificationVersion: string;
	TermsandConditionsMessage: string;
	TermsandConditionsNotification_ID: number;
	PrivacyPolicyMessage: string;
	PrivacyPolicyNotification_ID: number;
}

export const getMandatoryNotificationReadIds = (notification?: IMandatoryNotification): Array<number> => {
	if (!notification) return [];

	const ids =
		notification.Type_ID === TERMS_AND_CONDITIONS_TYPE_ID
			? [notification.TermsandConditionsNotification_ID, notification.PrivacyPolicyNotification_ID]
			: [notification.Notification_ID];

	return ids.filter((id) => Number.isInteger(id) && id > 0);
};
